import axios from 'axios';

const geoSwissApi = axios.create({
  baseURL: process.env.REACT_APP_GEO_SWISS_API,
});

geoSwissApi.interceptors.response.use((res) => res.data?.results);

export default geoSwissApi;
